import React from 'react';

/**
 * Approved identity board (1536 × 1024 raster). Every mark below is a true
 * crop of this artwork rendered through an SVG viewBox — the original pixels
 * are preserved and nothing is redrawn.
 */
const BOARD_SRC = 'https://cdn.magicpatterns.com/uploads/s5PtFCBpEFtTqdLj1FQrKb/black-comet-labs-concept-v5.png';
const BOARD_WIDTH = 1536;
const BOARD_HEIGHT = 1024;
type CropProps = {
  className?: string;
};
function BoardCrop({
  viewBox,
  className,
  label
}: {
  viewBox: string;
  className?: string;
  label?: string;
}) {
  const decorative = !label;
  return <svg viewBox={viewBox} className={className}
  // The approved artwork is raster with its own near-white ground.
  // Multiply blends it into Warm Cream without redrawing anything.
  style={{
    mixBlendMode: 'multiply'
  }} preserveAspectRatio="xMidYMid meet" role={decorative ? 'presentation' : 'img'} aria-label={decorative ? undefined : label} aria-hidden={decorative || undefined} focusable="false" data-id="element-10" data-mp="2u9cv128rpudg">
      <image href={BOARD_SRC} xlinkHref={BOARD_SRC} x={0} y={0} width={BOARD_WIDTH} height={BOARD_HEIGHT} data-id="element-11" data-mp="216xk6wsqkany" />
    </svg>;
}

/** Original heavy geometric BLACK COMET / spaced LABS wordmark. */
export function Wordmark({
  className
}: CropProps) {
  return <BoardCrop viewBox="110 642 845 170" className={className} label="Black Comet Labs" data-id="element-12" data-mp="268efmcsgb4x5" />;
}

/** The cat with the Comet Gold tail star. */
export function CatMark({
  className
}: CropProps) {
  return <BoardCrop viewBox="252 26 638 603" className={className} data-id="element-13" data-mp="1dkr0hd9y96hw" />;
}

/** Complete primary lockup: cat, star and wordmark together. */
export function PrimaryLockup({
  className
}: CropProps) {
  return <BoardCrop viewBox="100 26 860 788" className={className} label="Black Comet Labs" data-id="element-14" data-mp="1nfj0soux27gd" />;
}

/** Four-point Comet Gold star motif. */
export function CometStar({
  className
}: CropProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" focusable="false" data-id="element-15" data-mp="urwtb5ikiio8">
      <path d="M12 0c1.1 8.2 2.7 10.9 12 12-9.3 1.1-10.9 3.8-12 12-1.1-8.2-2.7-10.9-12-12C9.3 10.9 10.9 8.2 12 0Z" fill="currentColor" data-id="element-16" data-mp="2utwf9b40qo44" />
    </svg>;
}